// React & Nextjs imports
import React, { useMemo, useState } from "react";

// Hooks & Utils
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";

// Components
import ICMWrapper from "@/app/components/icm-wrapper";
import StockCategoryList from "@/app/global/components/stock-category-list";
// import stockCategoriesData from "@/app/global/components/stock-categories-data.json";
import DownloadAppPlusIconsWhite from "@/app/global/components/download-app-plus-icons-white";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
// import { useRemoteConfig } from "@/app/hooks/use-remote-config";
import { productRoute, ProductRoute } from "@/types/product";
import { useProductCategoryList } from "../use-us-stocks";
import { UsStockCategory } from "@/app/interface/global";
import GetICMAppModal from "@/app/components/get-icm-app-modal";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { DirectPaths } from "@/config/routes";

// const { categories } = stockCategoriesData as StockCategoriesData;

interface Props {
    pageRoute?: ProductRoute;
}

export default function BrowseStocks({ pageRoute }: Props) {
    const { productCategoryList: categories, isProductCategoryListLoading } =
        useProductCategoryList();

    // const { data: categories } = useRemoteConfig<CategoryResponse[]>("usStocksCategories", []);

    const [showAppModal, setShowAppModal] = useState<boolean>(false);

    const toggleDownloadApp = () => {
        setShowAppModal(!showAppModal);
    };

    const globalPagePath = useMemo(() => {
        return pageRoute === productRoute["us-stocks"]
            ? `${DirectPaths.GLOBAL + DirectPaths.US_STOCKS}`
            : (pageRoute === productRoute["us-etfs"] &&
                  `${DirectPaths.GLOBAL + DirectPaths.US_ETFS}`) ||
                  "";
    }, [pageRoute]);

    const eventNameFold1 = useMemo(() => {
        return `Home_Explore_Global_${pageRoute?.toUpperCase().replace("-", "_")}_Fold1`;
    }, [pageRoute]);

    return (
        <div className="bg-[#F4F4F7]">
            <ICMWrapper>
                <div className="flex flex-col items-center py-s15 md:py-s20">
                    <h2 className="mb-10 text-center text-4xl font-semibold -tracking-[0.56px] md:text-6xl md:leading-[67.2px]">
                        Browse US stocks by theme
                    </h2>

                    {isProductCategoryListLoading ? (
                        <div className="-mt-4 mb-8 h-5 w-full max-w-[30%] animate-pulse rounded-round bg-gray-300"></div>
                    ) : (
                        <>
                            {categories?.data?.categories &&
                            categories.data.categories?.length > 0 ? (
                                <StockCategoryList
                                    categories={categories?.data?.categories as UsStockCategory[]}
                                    className="mb-14 w-full"
                                    pageRoute={pageRoute}
                                />
                            ) : (
                                <span className="-mt-4 block">&nbsp;</span>
                            )}
                        </>
                    )}

                    <div className="w-full text-center">
                        <RegularButton
                            noIcon
                            showRightIcon={true}
                            rightIcon={
                                <DownloadAppPlusIconsWhite css="[&_path:nth-child(2)]:fill-white [&_path]:stroke-white" />
                            }
                            size={ButtonSize.Large}
                            variant={ButtonVariant.PrimaryDefault}
                            className="m-auto h-[60px] min-w-full md:min-w-[114px]"
                            label={"Download the app"}
                            onClick={() => {
                                setAnalyticsEvent(`${globalPagePath}`, `${eventNameFold1}`);
                                toggleDownloadApp();
                            }}
                        />
                    </div>
                </div>

                <GetICMAppModal open={showAppModal} onClose={toggleDownloadApp} />
            </ICMWrapper>
        </div>
    );
}
